const apiFilter = require('../../services/dashboard/dashboardService')
const state = {
    // token
    token: '',
    // filtro
    loading: true,
    selectedPeriod: 1,
    selectedFilter: { status: [], hosts: [], types: [], citys: [], clients: [], country: '', startDate: '', endDate: '' },
    tableItems: [],
    // ---------Google
    omsmarkes: [],
    google: [],
    appointmentsReload: [],
    cluster: null,
    markers: [],
    mapgoogle: false,
    infowindow: [],
    // -----reload appointment
    reloadAppointment: null,
}
const mutations = {
    setSelectedPeriod (state, payload) {
        state.selectedPeriod = payload
    },

    setOmsmarkes (state, payload) {
        state.omsmarkes = payload
    },
    setGoogle (state, payload) {
        state.google = payload
    },
    setAppointments (state, payload) {
        state.appointments = payload
    },
    setAppointmentsReload (state, payload) {
        state.appointmentsReload = payload
    },
    setClusterd (state, payload) {
        state.cluster = payload
    },
    setMarkers (state, payload) {
        state.markers = payload
    },
    setMapgoogle (state, payload) {
        state.mapgoogle = payload
    },
    setInfowindow (state, payload) {
        state.infowindow = payload
    },
    // table
    settableItems (state, payload) {
        state.tableItems = payload
    },
    // filter
    setLoading (state, payload) {
        state.loading = payload
    },
    setStartDates (state, payload) {
        state.selectedFilter.startDate = payload
    },
    setEndDates (state, payload) {
        state.selectedFilter.endDate = payload
    },
    setSelectedStatus (state, payload) {
        state.selectedFilter.status = payload
    },
    setSelectedTypes (state, payload) {
        state.selectedFilter.types = payload
    },
    setSelectedCitys (state, payload) {
        state.selectedFilter.citys = payload
    },
    setSelectedClients (state, payload) {
        state.selectedFilter.clients = payload
    },
    setSelectedHosts (state, payload) {
        state.selectedFilter.hosts = payload
    },
    setSelectedCountry (state, payload) {
        state.selectedFilter.country = payload
    },
    // token
    setToken (state, payload) {
        state.token = payload
    },

}
const actions = {
    async getFilter ({ commit }) {
        commit('setFilterHosts', await apiFilter.getHost(state.token))
        commit('setFilterTypes', await apiFilter.getTypes(state.token))
        commit('setFilterCitys', await apiFilter.getCity(state.token))
        commit('setFilterClients', await apiFilter.getClient(state.token))
        commit('setFilterStatus', await apiFilter.getStatus(state.token))
      },
}
const getters = {}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
